/**
 * Helmet Shim
 * Provides a unified import for react-helmet-async that works in both
 * browser (Vite/ESM) and SSR (Node/CommonJS) environments
 */

import * as HelmetAsync from 'react-helmet-async';

// Check if we're in SSR environment with pre-loaded module
const hasPreloaded = typeof globalThis !== 'undefined' && (globalThis as any).__helmetAsync;
const helmetSource = hasPreloaded ? (globalThis as any).__helmetAsync : HelmetAsync;

export const Helmet = helmetSource.Helmet;
export const HelmetProvider = helmetSource.HelmetProvider;
export const HelmetData = helmetSource.HelmetData;
